<template>
  <div>
    <CRow>
      <CCol  col="12">
        <CCard>

          <CCardBody>
<div style="height: 70vh;overflow: auto" id="message_support_root">
  <div v-for="msg in message_list">
    <div :class="`${msg.from_id==null ? 'support_message' : 'my_message'} admin-message`">
      <div class="font-weight-bold" v-if="msg.from_id==null">
        Admin
      </div>
      <div class="font-weight-bold" v-if="msg.to_id==null">
        You
      </div>
      <div>
        {{msg.message}}
      </div>
      <div>
        {{get_date_time(msg.created_at)  }}
      </div>

    </div>
  </div>

</div>
            <div>
              <CInput
                placeholder="message"
                v-model="message"
                @click.enter="send_message()"
                />
            </div>
            <CButton @click="send_message()"
                     color="primary"
            >
              Send
            </CButton>
          </CCardBody>

        </CCard>


      </CCol>
    </CRow>
    <!-- Modal for Add/Edit Line -->
  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      message:'',
      message_list:[],
    }
  },
  mounted() {
    this.get_messages();
  },
  watch: {

  },
  methods: {

    get_messages() {
      var self = this;
var formData = new FormData();
      // get_admin_messages
      // send_admin_messages
      // read_admin_messages
      // count_admin_messages
      axios.post('/api/admin/site/get_admin_messages',formData, {}).then(function (response) {


        self.message_list = response.data;
        setTimeout(function (){
          var objDiv = document.getElementById("message_support_root");
          objDiv.scrollTop = objDiv.scrollHeight;
        },300)

        bus.$emit('update_unread_message',{})
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    send_message() {
      var self = this;
var formData = new FormData();
      // get_admin_messages
      //
      // read_admin_messages
      // count_admin_messages
      if(this.message==''){
        return false;
      }
      formData.append('message',this.message)
      axios.post('/api/admin/site/send_admin_messages',formData, {}).then(function (response) {

        var content_cats = response.data;
if(response.data.error==0){
  self.message_list.push(
      {
        message:self.message,
        to_id:null,
        from_id:0,
        created_at:new Date(),
        updated_at:new Date(),

      }
  )
  self.message=''
  setTimeout(function (){
    var objDiv = document.getElementById("message_support_root");
    objDiv.scrollTop = objDiv.scrollHeight;
  },300)
}
        self.message_list = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>

<style>

.admin-message{
color:black;
  border-radius: 5px;
  margin: 5px 10px;
  padding: 5px;
}
.admin-message.support_message{
background: #d9fdd3;
  max-width: 50%;
}
.admin-message.my_message{
background: white;
  max-width: 50%;
  justify-self: right;
border: 1px solid #80808054;

}
</style>